/* =====================================================================
   Glimmer — sugestões da busca do cabeçalho
   O tema (templates/search.ajax.liquid) já mostra as sugestões com o texto digitado.
   Aqui elas são reordenadas e completadas:
   1) o que começa com o texto, depois o que tem o texto;
   2) dentro disso: buscas populares da Shopify, nomes de produtos, marcas/categorias;
   3) desempate: produtos mais vendidos primeiro (/collections/all ordenado por mais vendidos).
   Carregado em sections/header.liquid.
   ===================================================================== */
(function () {
  var MAX = 5;
  var rankVendas = null;           // handle -> posição na lista de mais vendidos
  var cacheSugestoes = {};         // termo -> buscas populares da Shopify

  function carregarVendas() {
    if (rankVendas) { return Promise.resolve(rankVendas); }
    return fetch('/collections/all/products.json?limit=250&sort_by=best-selling')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        rankVendas = {};
        (d.products || []).forEach(function (p, i) { rankVendas[p.handle] = i; });
        return rankVendas;
      })
      .catch(function () { rankVendas = {}; return rankVendas; });
  }

  function buscasPopulares(termo) {
    if (cacheSugestoes[termo]) { return Promise.resolve(cacheSugestoes[termo]); }
    return fetch('/search/suggest.json?q=' + encodeURIComponent(termo) + '&resources[type]=query&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var lista = ((d.resources && d.resources.results && d.resources.results.queries) || []).map(function (q) { return q.text; });
        cacheSugestoes[termo] = lista;
        return lista;
      })
      .catch(function () { return []; });
  }

  function nivel(texto, termo) {
    var t = texto.toLowerCase();
    if (t.indexOf(termo) === 0) { return 1; }
    return t.indexOf(termo) > -1 ? 2 : 0;
  }

  function criarLink(texto, base) {
    var a = document.createElement('a');
    a.className = 'glimmer-busca-sug';
    a.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(texto);
    a.innerHTML = (base && base.querySelector('svg') ? base.querySelector('svg').outerHTML : '') + '<span></span>';
    a.querySelector('span').textContent = texto;
    return a;
  }

  function reordenar(caixa) {
    if (!caixa || caixa.getAttribute('data-glimmer-ok')) { return; }
    caixa.setAttribute('data-glimmer-ok', '1');
    var termo = String(caixa.getAttribute('data-termo') || '').trim();
    var termoMin = termo.toLowerCase();
    if (!termoMin) { return; }
    var principal = caixa.querySelector('.glimmer-busca-sug--principal');

    Promise.all([carregarVendas(), buscasPopulares(termo)]).then(function (res) {
      var vendas = res[0];
      var populares = res[1];
      var vistos = {};
      var itens = [];
      vistos[termoMin] = true;

      populares.forEach(function (texto, i) {
        var k = texto.toLowerCase();
        if (vistos[k] || !nivel(texto, termoMin)) { return; }
        vistos[k] = true;
        itens.push({ texto: texto, nivel: nivel(texto, termoMin), grupo: 0, ordem: i });
      });
      caixa.querySelectorAll('.glimmer-busca-sug[data-tipo]').forEach(function (el, i) {
        var texto = el.textContent.trim();
        var k = texto.toLowerCase();
        if (vistos[k]) { return; }
        vistos[k] = true;
        var tipo = parseInt(el.getAttribute('data-tipo'), 10) || 3;
        var handle = el.getAttribute('data-handle');
        var venda = handle && vendas[handle] !== undefined ? vendas[handle] : 9999;
        itens.push({ texto: texto, nivel: nivel(texto, termoMin) || 2, grupo: tipo === 1 ? 1 : 2, ordem: tipo === 1 ? venda : 10000 + i, el: el });
      });

      itens.sort(function (a, b) { return a.nivel - b.nivel || a.grupo - b.grupo || a.ordem - b.ordem; });

      caixa.querySelectorAll('.glimmer-busca-sug:not(.glimmer-busca-sug--principal)').forEach(function (el) { el.remove(); });
      itens.slice(0, MAX).forEach(function (item) {
        caixa.appendChild(item.el || criarLink(item.texto, principal));
      });
    });
  }

  function observar(alvo) {
    new MutationObserver(function () {
      alvo.querySelectorAll('.glimmer-busca-sugestoes').forEach(reordenar);
    }).observe(alvo, { childList: true, subtree: true });
  }

  function iniciar() {
    document.querySelectorAll('.search-bar__results-inner').forEach(observar);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
})();
